/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OAuthProvider } from './OAuthProvider';
import {
    OAuthProviderFromJSON,
    OAuthProviderFromJSONTyped,
    OAuthProviderToJSON,
} from './OAuthProvider';

/**
 * 
 * @export
 * @interface OIDCTokensInfo
 */
export interface OIDCTokensInfo {
    /**
     * 
     * @type {string}
     * @memberof OIDCTokensInfo
     */
    authn_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OIDCTokensInfo
     */
    token_types: Array<string>;
    /**
     * 
     * @type {OAuthProvider}
     * @memberof OIDCTokensInfo
     */
    provider: OAuthProvider;
    /**
     * 
     * @type {string}
     * @memberof OIDCTokensInfo
     */
    client_id: string;
    /**
     * Groups the user belongs to in the OIDC provider
     * @type {Array<string>}
     * @memberof OIDCTokensInfo
     */
    oidc_groups?: Array<string>;
}

/**
 * Check if a given object implements the OIDCTokensInfo interface.
 */
export function instanceOfOIDCTokensInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "authn_id" in value;
    isInstance = isInstance && "token_types" in value;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function OIDCTokensInfoFromJSON(json: any): OIDCTokensInfo {
    return OIDCTokensInfoFromJSONTyped(json, false);
}

export function OIDCTokensInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCTokensInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authn_id': json['authn_id'],
        'token_types': json['token_types'],
        'provider': OAuthProviderFromJSON(json['provider']),
        'client_id': json['client_id'],
        'oidc_groups': !exists(json, 'oidc_groups') ? undefined : json['oidc_groups'],
    };
}

export function OIDCTokensInfoToJSON(value?: OIDCTokensInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authn_id': value.authn_id,
        'token_types': value.token_types,
        'provider': OAuthProviderToJSON(value.provider),
        'client_id': value.client_id,
        'oidc_groups': value.oidc_groups,
    };
}

